export enum AsyncComponentQuoteEnum {
  QuoteTabs = 'QuoteTabs',
  QuoteListForm = 'QuoteListForm',
  QuoteMutateForm = 'QuoteMutateForm',
  QuoteList = 'QuoteList',
  QuoteMutate = 'QuoteMutate',
  QuoteSearch = 'QuoteSearch',
  QuoteStepper = 'QuoteStepper',
  QuoteHeaderForm = 'QuoteHeaderForm',
  QuoteOptionalDetailMutateForm = 'QuoteOptionalDetailMutateForm'
}

export const quoteComponents = {
  [ AsyncComponentQuoteEnum.QuoteTabs ]: () => import( '@/components/quote/QuoteTabs.vue' ),
  [ AsyncComponentQuoteEnum.QuoteListForm ]: () => import( '@/components/quote/QuoteListForm.vue' ),
  [ AsyncComponentQuoteEnum.QuoteMutateForm ]: () => import( '@/components/quote/QuoteMutateForm.vue' ),
  [ AsyncComponentQuoteEnum.QuoteList ]: () => import( '@/views/quote/quoteList/QuoteList.vue' ),
  [ AsyncComponentQuoteEnum.QuoteMutate ]: () => import( '@/views/quote/quoteMutate/QuoteMutate.vue' ),
  [ AsyncComponentQuoteEnum.QuoteSearch ]: () => import( '@/components/quote/subComponents/QuoteSearch.vue' ),
  [ AsyncComponentQuoteEnum.QuoteStepper ]: () => import( '@/components/quote/subComponents/QuoteStepper.vue' ),
  [ AsyncComponentQuoteEnum.QuoteHeaderForm ]: () => import( '@/components/quote/subComponents/QuoteHeaderForm.vue' ),
  [ AsyncComponentQuoteEnum.QuoteOptionalDetailMutateForm ]: () => import( '@/components/quote/subComponents/QuoteOptionalDetailMutateForm.vue' )
}
